import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-semantic-high',
  templateUrl: './disable-semantic-high.component.html',
  styleUrls: ['./disable-semantic-high.component.css'],
})
export class DisableSemanticHighComponent {
  @Input() question!: Question;
}
